import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=763f6bca&scoped=true&lang=pug"
import script from "./CustomSearch.vue?vue&type=script&lang=js"
export * from "./CustomSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=763f6bca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f6bca",
  null
  
)

export default component.exports